import http from "./httpService";

const apiEndpoint = "/home-slider";

export function getHomeSlider() {
  return http.get(apiEndpoint);
}
